import { v4 as uuidv4 } from "uuid";

export function createUniqueFileName(file) {
  let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
  let nameWithoutExtension = file.name.substring(0, file.name.lastIndexOf("."));
  return `${nameWithoutExtension}-${uuidv4()}.${extension}`;
}
